/* storybook-check-ignore */
import { useState, ReactNode } from 'react';
import { Button, Flex, Text, Box } from '@opendoor/bricks/core';
import { motion } from 'framer-motion';
import { useDevice } from '@opendoor/bricks/hooks/useMedia';

interface BenefitProps {
  title: string;
  children: string | ReactNode;
  Icon: () => JSX.Element;
}

function ExpandIcon() {
  return (
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L6.07553 6L11.1511 1" stroke="#6E6E6E" />
    </svg>
  );
}

const Benefit = ({ Icon, title, children }: BenefitProps) => {
  const [expand, setExpand] = useState(false);
  const { isMobile } = useDevice();
  return (
    <Flex flexDirection="column">
      <Flex alignItems="center">
        <Box height="16px" width="16px" minHeight="16px" minWidth="16px">
          <Icon />
        </Box>
        <Text ml={5} fontSize="s1" color="neutrals100" fontWeight={expand ? 'semibold' : 'normal'}>
          {title}
        </Text>
        <Button
          as="a"
          ml="auto"
          width="auto"
          fontSize="s0"
          color="brand50"
          fontWeight="normal"
          aria-label="Learn more"
          backgroundColor="transparent"
          onClick={() => setExpand((prev) => !prev)}
          _hover={{ backgroundColor: 'transparent' }}
          analyticsName="cosmos-exclusives-benefits-learn-more"
          whiteSpace="nowrap"
          justifyContent="flex-end"
          {...(isMobile && {
            style: { color: '#6E6E6E' },
            transition: 'transform 0.25s ease-in-out',
            transform: expand ? 'rotate(180deg)' : undefined,
          })}
        >
          {isMobile ? <ExpandIcon /> : expand ? 'Close' : 'Learn more'}
        </Button>
      </Flex>
      {expand && (
        <motion.div
          layout
          key={`benefitContent:${title}`}
          transition={{ type: 'tween' }}
          exit={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          initial={{ opacity: 0, x: -10 }}
        >
          <Text fontSize="s1" lineHeight="s1" mb="2rem" mt="4" ml="32px">
            {children}
          </Text>
        </motion.div>
      )}
    </Flex>
  );
};

export default Benefit;
